/** Replaced by the value in package.json on build */
export default "VERSION_PLACEHOLDER" as string;
